<template>
    <div class="row w-100 h-100 flex-column">

        <div class="col d-flex flex-column justify-content-center align-items-center cursor-pointer h-80">
            <div>
                <router-link class="d-flex align-items-center flex-column no-ref" :to="link">
                    <slot name="icon"></slot>
                    <slot name="description"></slot>
                </router-link>
            </div>        
        </div>

        <div class=" d-flex h-20" v-if="active">
            <div class="active-menu "></div>        
        </div>

    </div>
        

</template>

<script>
export default {
    name:"BottomNavItem",
    props: {
        link: {
            type:String,
            required:true
        },
        active: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="css" scoped>
    @import "./style.css";

    .active-menu {
        height:2px;
        width: 100%;
        background-color: rgb(243, 115, 11);
    }

    .no-ref {
        text-decoration: none;
    }

    
</style>
